"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tabs_1 = require("../Tabs");
var Forms_1 = require("./Forms");
var AddressDetailsForm_1 = __importDefault(require("./Forms/AddressDetailsForm"));
var ContactDetailsForm_1 = __importDefault(require("./Forms/ContactDetailsForm"));
var PersonalDetailsForm_1 = __importDefault(require("./Forms/PersonalDetailsForm"));
function ClientFormBody(props) {
    var children = props.children;
    return (react_1.default.createElement(Tabs_1.TabPanels, null,
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.personal" },
                react_1.default.createElement(PersonalDetailsForm_1.default, { tabId: "details.personal" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.contact" },
                react_1.default.createElement(ContactDetailsForm_1.default, { tabId: "details.contact" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.medical" },
                react_1.default.createElement(Forms_1.MedicalDetailsForm, { tabId: "details.medical" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.ethnicity" },
                react_1.default.createElement(Forms_1.EthnicityDetailsForm, { tabId: "details.ethnicity" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.address" },
                react_1.default.createElement(AddressDetailsForm_1.default, { tabId: "details.address" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.restrictions" },
                react_1.default.createElement(Forms_1.RestrictionsDetailsForm, { tabId: "details.restrictions" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "disabilities" },
                react_1.default.createElement(Forms_1.DisabilitiesForm, { tabId: "disabilities" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "comments" },
                react_1.default.createElement(Forms_1.CommentsForm, { tabId: "comments" })),
            react_1.default.createElement(Tabs_1.TabPanel, { identifier: "details.carers" },
                react_1.default.createElement(Forms_1.CarersDetailsForm, { tabId: "details.carers" })),
            children)));
}
exports.default = ClientFormBody;
//# sourceMappingURL=ClientFormBody.js.map